import { render, staticRenderFns } from "./LogsModal.vue?vue&type=template&id=1fda6ef2&scoped=true&"
import script from "./LogsModal.vue?vue&type=script&lang=js&"
export * from "./LogsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fda6ef2",
  null
  
)

export default component.exports